import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import newHistoryDuck from 'ducks/new-history-duck';
import CancelMultipleConfirmModal from 'components/history/modal/cancel-multiple-confirm-modal';
import FeedbackModal from './feedback-modal';

const useCancelDeliveries = () => {
  const dispatch = useDispatch();
  const [reasonModalVisible, setReasonModalVisible] = useState(false);
  const [cancelConfirmationVisible, setCancelConfirmationVisible] = useState(
    false,
  );
  const [deliveriesToCancel, setDeliveriesToCancel] = useState(undefined);

  const resetAll = useCallback(
    () => {
      setReasonModalVisible(false);
      setCancelConfirmationVisible(false);
      setDeliveriesToCancel(undefined);
    },
    [
      setReasonModalVisible,
      setCancelConfirmationVisible,
      setDeliveriesToCancel,
    ],
  );

  const doCancelAndShowFeedbackPopup = useCallback(
    deliveries => {
      dispatch(newHistoryDuck.creators.cancelDeliveries(deliveries));
      setCancelConfirmationVisible(false);
      setReasonModalVisible(true);
    },
    [setCancelConfirmationVisible, setReasonModalVisible],
  );

  const doSubmitCancelReason = useCallback(
    cancelRequest => {
      dispatch(
        newHistoryDuck.creators.submitCancelReasonForDeliveries(
          deliveriesToCancel,
          cancelRequest,
        ),
      );
      resetAll();
    },
    [dispatch, deliveriesToCancel, resetAll],
  );

  const startCancellation = useCallback(
    (deliveries, cancelConfirmation) => {
      dispatch(newHistoryDuck.creators.listCancellationReasons(deliveries));
      setDeliveriesToCancel(deliveries);
      if (cancelConfirmation) {
        setCancelConfirmationVisible(true);
      } else {
        doCancelAndShowFeedbackPopup(deliveries);
      }
    },
    [
      setCancelConfirmationVisible,
      setDeliveriesToCancel,
      setReasonModalVisible,
    ],
  );

  const confirmCancel = useCallback(
    () => {
      doCancelAndShowFeedbackPopup(deliveriesToCancel);
    },
    [deliveriesToCancel, doCancelAndShowFeedbackPopup],
  );

  const modalDOMs = useMemo(
    () => (
      <React.Fragment>
        <CancelMultipleConfirmModal
          handleClose={resetAll}
          visible={cancelConfirmationVisible}
          handleCancelOrderModal={confirmCancel}
          orderAmt={deliveriesToCancel && deliveriesToCancel.length}
        />
        <FeedbackModal
          visible={reasonModalVisible}
          handleSubmit={doSubmitCancelReason}
        />
      </React.Fragment>
    ),
    [
      reasonModalVisible,
      doSubmitCancelReason,
      cancelConfirmationVisible,
      deliveriesToCancel,
    ],
  );

  return {
    startCancellation,
    modalDOMs,
  };
};

export default useCancelDeliveries;
